import { Box, Typography } from "@mui/material";
import { getArrowIcon } from "pages/provider/claimCodingOpt/helper";
import React from "react";

const LegendItem = ({ label, value, showPer }) => {
  const isPositive = parseFloat(value) > 0;
  return (
    <Box display="flex" py={0.5} px={1}>
      <Typography variant="body2" fontWeight="bold" mr={2}>
        {label}:
      </Typography>
      {!showPer ? (
        <Typography variant="body2">{value}</Typography>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          fontWeight={isPositive ? "bold" : "normal"}
        >
          <Typography variant="body2">{value}</Typography>

          {getArrowIcon(value, "small")}
        </Box>
      )}
    </Box>
  );
};

export default LegendItem;
